import { useMemo, useState } from 'react';
import { Dropdown, DropdownProps } from 'semantic-ui-react';
import { Icon, IconName } from 'react-frontier';

interface InventoryIconDropdownOption{
   key: number;
   value: number | null;
   text: string;
   icon?: IconName | string;
}

interface InventoryIconDropdownProps extends Omit<DropdownProps, 'options' | 'value' | 'onChange'>{
   options: InventoryIconDropdownOption[];
   value: number | null;
   placeholder?: string;
   onChange: (value: number)=> void;
	disabled?: boolean;
}

var InventoryIconDropdown =({options, value, placeholder = 'Selecciona un ícono', onChange, className: dropdownClassName, disabled, ...dropdownProps}: InventoryIconDropdownProps)=>{
   var [open, setOpen] = useState(false);

   var normalizedOptions = useMemo(()=>
      options.map(opt=>({
         ...opt,
         icon: opt.icon ? <Icon name={opt.icon as IconName} /> : undefined,
      })), [options]
   );

   var trigger = useMemo(()=>{
      if(open) return undefined;
      var selectedOption = normalizedOptions.find(opt=>opt.value === value);

      if(!selectedOption) return(<span style={{ color: '#999' }}>{placeholder}</span>);

      return(
         <span style={{display: 'flex', alignItems: 'center', gap: 6}}>
            {selectedOption.icon}
            {selectedOption.text}
         </span>
      );
   }, [open, value, normalizedOptions, placeholder]);

   var onIconChange = (_: any, data: DropdownProps)=>{
      onChange((data.value as number) || null);
   };

   var className = useMemo(()=>{
      if (!dropdownClassName)return 'selection';
      return ['selection', dropdownClassName].join(' ');
   }, [dropdownClassName]);

   return (
      <Dropdown
         search
         fluid
         placeholder={placeholder}
         options={normalizedOptions}
         value={value || undefined}
         onChange={onIconChange}
         trigger={trigger}
         onOpen={()=> setOpen(true)}
         onClose={()=> setOpen(false)}
         className={className}
			disabled={disabled}
         {...dropdownProps}
      />
   );
};

export type { InventoryIconDropdownOption };
export default InventoryIconDropdown;
